import { useContext } from 'react';

import { type ConfirmOptions, DialogContext, type SuccessOptions } from './dialog-host';

export type { ConfirmOptions, SuccessOptions };

function useDialogContext() {
  const ctx = useContext(DialogContext);
  if (!ctx) {
    throw new Error('useConfirm/useDialog must be used within <DialogHost>');
  }
  return ctx;
}

/** Imperative confirmation dialog. `confirm()` resolves true/false. */
export function useConfirm() {
  const { confirm } = useDialogContext();
  return { confirm };
}

/** Imperative acknowledgment dialogs (success). Manual close only. */
export function useDialog() {
  const { confirm, success } = useDialogContext();
  return { confirm, success };
}
